export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_URL || 'https://api.practicalmedia.com',
  ASSETS_URL: import.meta.env.VITE_ASSETS_URL || 'https://assets.practicalmedia.com',
  TIMEOUT: 10000,
};

export const getHeaders = () => ({
  'Content-Type': 'application/json',
});